// Guest order access tokens (LOT 1): kept only in this browser so the buyer can come back
// to /commande/:id. The server stores just a digest; the token itself is the access proof.
const KEY = (orderId: string) => `sokoby:order-access:${orderId}`;
export const GUEST_TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;

export function saveGuestOrderToken(orderId: string, token: string) {
  if (!GUEST_TOKEN_PATTERN.test(token)) return;
  try { localStorage.setItem(KEY(orderId), token); } catch { /* storage unavailable */ }
}

export function getGuestOrderToken(orderId: string): string | null {
  try {
    const t = localStorage.getItem(KEY(orderId));
    return t && GUEST_TOKEN_PATTERN.test(t) ? t : null;
  } catch { return null; }
}

export function guestOrderLink(origin: string, orderId: string, token: string) {
  return `${origin}/commande/${orderId}?t=${token}`;
}
